<template>
  <div class="page-container attribute-editor">
    <div class="page-title-container">
      <h1 class="page-title" v-if="attribute">
        <!-- {{ editing ? "Editar atributo" : "Nuevo atributo" }} -->
        {{ attribute.name }}: {{ editing ? value.name : "Nuevo valor" }}
      </h1>
    </div>
    <div class="container px-0">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8">
          <b-card
            tag="article"
            no-body
            style="max-width: 640px"
            class="custom-card"
          >
            <b-card-header
              header-tag="section"
              class="custom-card-header d-flex align-items-center"
            >
              <h3>
                {{ editing ? "Datos del valor" : "Datos del nuevo valor" }}
              </h3>
            </b-card-header>
            <b-card-body class="custom-card-body px-0 pb-0">
              <form class="custom-form" @submit.prevent="save" novalidate>
                <div class="form-section pt-0">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group mb-0">
                        <label for="name">Descripción *</label>

                        <FormInput
                          id="name"
                          type="text"
                          placeholder="Ingresar descripción"
                          :showError="$v.value.name.$error"
                          v-model="value.name"
                        />

                        <form-error
                          message="Descripción es requerida"
                          v-if="$v.value.name.$error && !$v.value.name.required"
                        ></form-error>
                      </div>
                    </div>
                  </div>

                  <div class="form-group-buttons text-right">
                    <router-link
                      :to="{ name: 'config-attributes-details', params: { attributeId: attribute.id } }"
                      class="button button-light"
                    >
                      {{ editing ? "Volver" : "Cancelar" }}
                    </router-link>
                    <button class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </form>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert, FormInput, FormError } from "wize-admin";

import { AttributeService } from "@/core/services";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      attribute: {},
      value: {
        name: null,
      },
      editing: false,
    };
  },
  components: {
    FormInput,
    FormError
  },
  validations: {
    value: {
      name: { required },
    },
  },
  watch: {
    "$route.params.valueId": function () {
      if (this.$route.params.valueId) this.load(this.$route.params.valueId);
    },
  },
  computed: {},
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });
        return;
      }

      this.$store.dispatch("app/loading", true)

      const data = { ...this.value };

      try {
        let response;
        if (!this.editing) {
          response = await AttributeService.createAttributeValue(this.attribute.id, data);
        } else {
          response = await AttributeService.updateAttributeValue(
            this.attribute.id,
            this.value.id,
            data
          );
        }

        Alert.success("Se almacenó la información correctamente");
        if (!this.editing) {
          this.$router.push({
            name: "config-attributes-edit-value",
            params: {
              attributeId: this.attribute.id,
              valueId: response.payload.id,
            },
          });
          this.editing = true;
        }
        this.$store.commit('app/setAttributes', null)
      } catch (ex) {
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false)
      }
    }
  },
  async created() {
    try {
      this.$store.dispatch("app/loading", true);
      const response = await AttributeService.get(
        this.$route.params.attributeId
      );
      this.attribute = { ...response.payload };

      // Obtener los valores de los atributos y buscar por el id
      if(this.$route.params.valueId) {
        this.value = this.attribute.values.find(item => item.id == this.$route.params.valueId)
        this.editing = true
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.$store.dispatch("app/loading", false);
    }
  },
};
</script>

<style lang="stylus" scoped></style>
